export default class Version {

    constructor(cscom) {
        if (!(this instanceof Version)) {
            return new Version(cscom);
        }
        this.cscom = cscom;
    }

    show(data) {
        return this.cscom.req.get('/customer-site-api/version', null, data);
    }

}
